import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Offer, OfferItem } from '../../../model/offer/Offer';
import { OfferService } from '../OfferService';
import { ErrorToast } from '../../../utils/toasters';
import { priceSplitter } from '../../../utils/helpers/NumberFormater';

interface Props {
    offer?: Offer | null;
    show: boolean;
    onHide: () => void;
    onSubmit: (data: { price: number; description?: string }) => void;
}

export const AddAdditionalItemModal: React.FC<Props> = ({ offer, show, onHide, onSubmit }) => {
    const [price, setPrice] = useState<number | ''>('');
    const [description, setDescription] = useState('');
    const [additionalItems, setAdditionalItems] = useState<OfferItem[] | []>([]);
    const offerId = offer?.id;

    const handleSubmit = () => {
        if (!price) return;
        onSubmit({
            price: Number(price),
            description,
        });
        onHide();
        setPrice(0);
        setDescription('');
    };
    useEffect(() => {
        if (!offer?.id) return;

        OfferService.getAdditionalItems(offerId)
            .then(data => {
                setAdditionalItems(data);
            })
            .catch(err => ErrorToast(err));
    }, [offerId, show]);

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Add Additional Item on offer with ID: {offerId}
                    <br />
                    <span className={`status ${offer?.status}`}>{offer?.status}</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Price</Form.Label>
                        <Form.Control
                            type="number"
                            value={price}
                            onChange={e => setPrice(e.target.value ? Number(e.target.value) : '')}
                            placeholder="Enter price"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                            placeholder="Add description..."
                        />
                    </Form.Group>
                </Form>
                {additionalItems.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2">Existing Additional Items</h6>
                        <ul>
                            {additionalItems.map(item => (
                                <li key={item.id}>
                                    {item.description || 'No description'} — {priceSplitter(item.price ?? 0)} €
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-primary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
